import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "OK",
    cancel: "Batal",
    loginRegister: "Log masuk / Daftar",
    userAgreement: "Terma Perkhidmatan",
    privacyPolicy: "Dasar Privasi",
    notBound: "Belum ditetapkan",
  },
  tabbar: {
    home: "Utama",
    search: "Cari",
    library: "Pustaka",
    mine: "Saya",
    badgeLogin: "Log masuk",
    badgeUpgrade: "Naik taraf",
  },
  login: {
    navTitle: "Log masuk",
    welcome: "Selamat datang ke {brand}",
    subtitle: "Log masuk guna SMS, atau WeChat / QQ",
    subtitleGlobal: "Main terus sebagai tetamu, atau log masuk dengan Google / Telegram / Facebook",
    mobileLabel: "Telefon",
    mobilePlaceholder: "Nombor telefon",
    codeLabel: "Kod",
    codePlaceholder: "Kod SMS",
    getCode: "Dapatkan kod",
    resendIn: "Hantar semula dalam {sec}s",
    agreement:
      "Nombor yang belum berdaftar akan didaftarkan secara automatik. Dengan meneruskan, anda bersetuju dengan {userAgreement} dan {privacyPolicy}",
    otherMethods: "Cara log masuk lain",
    guest: "Teruskan sebagai tetamu",
    wechat: "Log masuk dengan WeChat",
    qq: "Log masuk dengan QQ",
    google: "Teruskan dengan Google",
    telegram: "Teruskan dengan Telegram",
    facebook: "Teruskan dengan Facebook",
    wechatComingSoon: "Log masuk WeChat akan datang",
    qqComingSoon: "Log masuk QQ akan datang",
    googleComingSoon: "Log masuk Google akan datang",
    googleFailed: "Log masuk Google gagal, sila cuba lagi",
    telegramFailed: "Log masuk Telegram gagal, sila cuba lagi",
    facebookComingSoon: "Log masuk Facebook akan datang",
    mobileInvalid: "Sila masukkan nombor telefon yang sah",
    codeInvalid: "Sila masukkan kod",
    codeSent: "Kod dihantar",
  },
  loginPrompt: {
    defaultMessage: "Log masuk untuk lihat permainan anda",
  },
  settings: {
    navTitle: "Tetapan",
    loginPrompt: "Log masuk untuk urus tetapan akaun",
    nickname: "Nama panggilan",
    mobile: "Telefon",
    controller: "Tetapan pengawal",
    controllerDesc: "Sensitiviti tetikus / joistik kanan / tukar butang",
    about: "Tentang",
    clearCache: "Kosongkan cache tempatan",
    language: "Bahasa",
    editNickname: "Edit nama panggilan",
    nicknamePlaceholder: "Nama panggilan baharu",
    nickEmpty: "Nama panggilan tidak boleh kosong",
    nickTooLong: "Nama panggilan maksimum 16 aksara",
    updated: "Dikemas kini",
    cacheCleared: "Dikosongkan. Sila log masuk semula",
    aboutTitle: "Tentang {brand}",
    aboutVersion: "Versi Web v{version}",
    aboutBody:
      "Permainan awan yang membolehkan anda main permainan AAA terus dalam pelayar, di mana sahaja.\nSemua kandungan permainan adalah hak milik penerbit masing-masing.",
  },
  subscription: {
    choosePlan: "Pilih pelan",
    included: "Yang disertakan",
    orderSummary: "Ringkasan pesanan",
    total: "Jumlah",
    continue: "Teruskan",
    secureNote: "Pembayaran selamat · Pembelian sekali",
    navTitle: "Naik taraf",
    unlockTitle: "Buka kunci faedah ahli",
    expired: "Tamat tempoh",
    daysLeft: "Tinggal {days} hari",
    validUntil: "Sah sehingga {time}",
    tagline: "Tanpa beratur, sesi lebih lama, kualiti lebih tinggi",
    perDay: "Sekitar {price}/hari",
    recommended: "Nilai terbaik",
    currentLevel: "Pelan semasa",
    footer:
      "Ini ialah pas keahlian pembelian sekali. Tempoh yang dipilih akan ditambah selepas pembayaran disahkan dan tidak akan diperbaharui secara automatik.",
    planVipMonth: "VIP Bulanan",
    planSvipMonth: "SVIP Bulanan",
    perkNoQueue: "Langkau giliran",
    perkDailyFree: "60 minit percuma sehari",
    perkHd: "Kualiti HD",
    perkAllVip: "Semua faedah VIP",
    perkUnlimited: "Masa main tanpa had",
    perk4k: "4K / 60fps",
    perkSupport: "Sokongan keutamaan",
    cnPayComingSoon:
      "Pembayaran WeChat / Alipay di web akan datang — sila guna apl buat masa ini",
    intlPayComingSoon: "Pembayaran Stripe / PayPal akan datang",
    payProcessing: "Lengkapkan pembayaran dan biarkan halaman ini terbuka…",
    paySuccess: "Pembayaran berjaya — keahlian diaktifkan",
    payFailed: "Pembayaran gagal, sila cuba lagi",
    payCancelled: "Pembayaran dibatalkan",
    telegramExtraTimeUnavailable: "Pembelian masa bermain dalam Telegram akan tersedia selepas versi Stars ditambah.",
    payUnconfirmed:
      "Pembayaran belum disahkan; jika anda telah membayar, ia akan dikreditkan tidak lama lagi",
    payPopupBlocked:
      "Tetingkap pembayaran disekat — sila benarkan tetingkap timbul dan cuba lagi",
    loadPlansFailed: "Gagal memuatkan pelan, sila cuba lagi",
    retry: "Cuba lagi",
  },
  app: {
    backToDesktop: "Kembali ke desktop",
  },
  titles: {
    home: "Utama",
    search: "Cari",
    detail: "Butiran permainan",
    library: "Pustaka",
    category: "Kategori",
    mine: "Saya",
    myGames: "Permainan saya",
    reviews: "Ulasan",
    gameVideos: "Video permainan",
    commentReplies: "Komen",
    saves: "Simpanan",
    subscription: "Naik taraf",
    signIn: "Daftar masuk harian",
    settings: "Tetapan",
    controlSettings: "Tetapan pengawal",
    login: "Log masuk",
    play: "Sedang main",
  },
  home: {
    searchPlaceholder: "Cari permainan",
    sectionDefault: "Permainan",
    allGames: "Semua permainan",
    more: "Lagi",
    empty: "Belum ada apa-apa di sini",
    latestOnline: "Keluaran baharu",
    comingSoon: "Akan datang",
    subscribe: "Beritahu saya",
    subscribed: "Ditempah",
    score: "Penilaian",
    subscribeSuccess: "Berjaya ditempah — kami akan beritahu apabila dilancarkan",
  },
  nav: {
    home: "Utama",
    library: "Pustaka",
    searchPlaceholder: "Cari permainan",
    me: "Saya",
    guest: "Tetamu",
    profile: "Profil",
    myGames: "Permainan saya",
    dailyCheckIn: "Daftar masuk harian",
    renewMembership: "Perbaharui keahlian",
    upgradeMembership: "Naik taraf keahlian",
    settings: "Tetapan",
    switchToMobile: "Tukar ke mudah alih",
    logout: "Log keluar",
    logoutConfirm: "Adakah anda pasti mahu log keluar?",
    mobileVersion: "Mudah alih",
    login: "Log masuk",
  },
  library: {
    all: "Semua",
    noMore: "Tiada lagi",
    loading: "Memuatkan…",
    noData: "Tiada data",
    noGames: "Tiada permainan",
    noUpcoming: "Tiada permainan akan datang",
    emptyCategory: "Tiada permainan dalam kategori ini",
  },
  mine: {
    notLoggedIn: "Belum log masuk",
    loginSyncTip: "Log masuk untuk segerakkan keahlian, kegemaran dan sejarah permainan",
    loginSyncTipDesktop:
      "Log masuk untuk lihat profil, keahlian, daftar masuk dan sejarah permainan anda",
    guest: "Tetamu",
    daysLeft: "Tinggal {n} hari",
    expired: "Tamat tempoh",
    renewBanner: "{level} anda tamat dalam {n} hari — perbaharui untuk diskaun 30%",
    membershipExpiredRenew: "Keahlian anda telah tamat — perbaharui sekarang",
    membershipExpired: "Keahlian tamat tempoh",
    membershipDaysLeft: "Tinggal {n} hari keahlian",
    gameTime: "Masa main",
    minUnit: "min",
    dailyCheckIn: "Daftar masuk harian",
    upgrade: "Naik taraf",
    renew: "Perbaharui",
    upgradeMembership: "Naik taraf keahlian",
    renewMembership: "Perbaharui keahlian",
    membership: "Keahlian",
    myCollection: "Kegemaran saya",
    collectedGames: "Permainan disimpan",
    recentlyPlayed: "Baru dimainkan",
    gameHistory: "Sejarah permainan",
    settings: "Tetapan",
    switchToDesktop: "Tukar ke desktop",
    accountAndPrefs: "Akaun & keutamaan",
    claimGameTime: "Dapatkan masa main",
    bindPhone: "Ikat nombor telefon",
    bindPhoneDesc: "Naik taraf ke akaun penuh dan segerakkan merentas peranti",
    bindPhoneDescDesktop: "Naik taraf ke akaun penuh, segerakkan merentas peranti",
    resetGuest: "Set semula identiti tetamu",
    resetGuestDesc: "Kosongkan akaun tetamu ini dan mula semula",
    resetGuestDescDesktop: "Mula semula dengan identiti baharu",
    logout: "Log keluar",
    myGamesTitle: "Permainan saya",
    collectTab: "Kegemaran",
    loginViewCollect: "Log masuk untuk lihat permainan yang disimpan",
    noCollect: "Belum ada permainan disimpan",
    loginViewHistory: "Log masuk untuk lihat sejarah permainan",
    noHistory: "Tiada permainan dimainkan baru-baru ini",
    weekMon: "Isn",
    weekTue: "Sel",
    weekWed: "Rab",
    weekThu: "Kha",
    weekFri: "Jum",
    weekSat: "Sab",
    weekSun: "Ahd",
    alreadySignedToday: "Sudah daftar masuk hari ini",
    signSuccessReward: "Daftar masuk! +{n} min",
    signSuccess: "Daftar masuk",
    loginJoinCheckIn: "Log masuk untuk sertai daftar masuk harian",
    claimed: "Dituntut",
    unclaimed: "Terlepas",
    todayDone: "Hari ini ✓",
    today: "Hari ini",
    dayN: "Hari {n}",
    signedToday: "Daftar masuk hari ini",
    signNow: "Daftar masuk sekarang",
    checkInTip1: "Daftar masuk setiap hari untuk dapatkan masa main percuma.",
    checkInTip2: "Hari yang terlepas boleh diganti dengan syiling di halaman ganti.",
    loggedOut: "Telah log keluar",
    resetGuestConfirm:
      "Ini akan memadam akaun tetamu semasa dan bermula semula dengan identiti baharu. Langganan, kegemaran dan sejarah yang dibeli akan hilang semua. Teruskan?",
    resetGuestConfirmBtn: "Set semula",
    resetting: "Menetapkan semula…",
    resetDone: "Set semula selesai — sila log masuk semula",
  },
  reviews: {
    recommendRate: "cadangan",
    tooFew: "Ulasan masih sedikit",
    count: "{n} ulasan",
    playFirst: "Main dulu untuk menulis ulasan",
    rateThis: "Dah main? Beri ulasan",
    mine: "Saya punya",
    edit: "Edit",
    delete: "Padam",
    report: "Lapor",
    played: "Main {d}",
    contentEmpty: "Ulasan tidak boleh kosong",
    editReview: "Edit ulasan",
    editDone: "Dikemas kini",
    published: "Ulasan dihantar",
    deleteTitle: "Padam ulasan?",
    deleteConfirm: "Tindakan ini kekal. Padam ulasan ini?",
    deleted: "Dipadam",
    reportTitle: "Lapor",
    reportConfirm: "Lapor kandungan ini? Pasukan kami akan menyemak.",
    reported: "Dilaporkan",
    deleteReplyTitle: "Padam balasan?",
    deleteReplyConfirm: "Padam balasan ini?",
    replyTo: "membalas",
    viewAllReplies: "Lihat semua {n} balasan",
    loadMore: "Muat lagi",
    allReplies: "Semua balasan ({n})",
    commentDeleted: "Ulasan ini telah dipadam",
    commentShielded: "Ulasan ini disembunyikan",
    replyDeleted: "Balasan ini telah dipadam",
    replyShielded: "Balasan ini disembunyikan",
  },
  detail: {
    svipRequiredMsg: "Permainan ini memerlukan SVIP untuk dimainkan",
    timeInsufficientMsg: "Masa permainan tidak mencukupi. Sila beli masa permainan dahulu.",
    goBuy: "Beli Sekarang",
    thinkAgain: "Fikir semula",
    navTitle: "Butiran permainan",
    back: "Kembali",
    svipOnly: "SVIP sahaja",
    vipOnly: "VIP sahaja",
    freeMinutes: "{n} min percuma",
    saveManage: "Simpanan",
    saveManageDesc: "Lihat / pulihkan simpanan lalu dan tambah nota",
    liveVideos: "Video permainan",
    more: "Lagi",
    viewAll: "Lihat semua",
    viewAllCount: "Lihat semua {n}",
    intro: "Tentang permainan ini",
    screenshots: "Tangkapan skrin",
    controlMethod: "Kawalan: ",
    playerReviews: "Ulasan",
    commentCount: "{n}",
    recommend: "Disyorkan",
    notRecommend: "Tidak disyorkan",
    similarGames: "Permainan serupa",
    collect: "Kegemaran",
    collected: "Digemari",
    collectStar: "☆ Kegemaran",
    collectedStar: "★ Digemari",
    unfavorited: "Dialih keluar dari kegemaran",
    entering: "Sedang masuk…",
    unlockSvip: "Buka kunci dengan SVIP",
    unlockVip: "Buka kunci dengan VIP",
    startGame: "Main",
    reviewCount: "{n} ulasan",
    sortHot: "Teratas",
    sortNew: "Terbaharu",
    noMore: "Tiada lagi",
    playedHours: "Dimainkan {n} jam",
    report: "Lapor",
    reportTitle: "Lapor komen ini?",
    reportMessage: "Pasukan penyederhana kami akan menyemaknya. Teruskan lapor?",
    reported: "Dilaporkan",
    noReviews: "Belum ada ulasan — jadilah yang pertama",
    writeReview: "Tulis ulasan",
    reviewPlaceholder: "Kongsi pengalaman anda… (sekurang-kurangnya 5 aksara)",
    reviewMinLength: "Ulasan mesti sekurang-kurangnya 5 aksara",
    reviewSubmitted: "Ulasan dihantar",
    publish: "Terbit",
    commentDetail: "Komen",
    replyCount: "{n} balasan",
    noReplies: "Belum ada balasan — jadilah yang pertama",
    reply: "Balas",
    replyToUser: "Balas {'@'}{name}",
    saySomething: "Tulis sesuatu…",
    send: "Hantar",
    sent: "Dihantar",
    videoCount: "{n} video",
    watchCount: "{k}k tontonan",
    noVideos: "Belum ada video",
    videoUnavailable: "Video ini tidak boleh dimainkan sekarang",
    videoUnavailableDesc: "Mungkin klip lama yang telah dialih keluar — cuba yang lain",
  },
  search: {
    placeholder: "Masukkan nama permainan",
    emptyHint: "Cari mengikut nama permainan atau pinyin",
    history: "Carian terkini",
    clear: "Kosongkan",
    noResults: "Tiada permainan ditemui",
  },
  misc: {
    savesTitle: "Simpanan Permainan",
    savesTitleNamed: "{name} - Simpanan",
    savesLoginPrompt: "Log masuk untuk lihat simpanan permainan anda",
    savesActiveHeading: "Simpanan aktif",
    savesUnnamed: "Simpanan tanpa nama",
    savesEditRemark: "Namakan semula",
    savesEmpty: "Belum ada simpanan awan",
    savesEmptyHint: "Simpanan dalam permainan disegerakkan ke sini secara automatik",
    savesHistory: "Sejarah",
    savesCount: "{n} simpanan",
    savesCurrent: "Semasa",
    savesCorrupted: "Rosak",
    savesRestore: "Pulihkan",
    savesNoHistory: "Tiada sejarah simpanan",
    savesFooter:
      "Simpanan dicetuskan oleh simpanan manual / automatik dalam permainan dan disegerakkan ke awan secara automatik. Pemadaman manual belum disokong buat masa ini (terus menyimpan dalam permainan akan menulis ganti yang paling lama).",
    savesRemarkTitle: "Edit catatan simpanan",
    savesRemarkPlaceholder: "Namakan simpanan ini, cth. \"Tamat Bab 1\"",
    savesSave: "Simpan",
    savesAlreadyCurrent: "Ini sudah menjadi simpanan semasa",
    savesRestoreTitle: "Pulihkan simpanan",
    savesRestoreConfirm:
      "Pulihkan ke simpanan ini? Kali seterusnya anda melancarkan, permainan bermula dari \"{name}\".",
    savesSwitched: "Bertukar ke simpanan ini",
    savesSaved: "Disimpan",
    ctrlNavTitle: "Tetapan Pengawal",
    ctrlSave: "Simpan",
    ctrlIntro:
      "Laraskan rasa tetikus / pengawal di sini. Membiarkan sebarang nilai kosong / 0 akan mengikut lalai pelayan setiap permainan; perubahan dikenakan pada semua permainan.",
    ctrlMouseSensitivity: "Sensitiviti tetikus",
    ctrlServerDefault: "Lalai pelayan",
    ctrlMouseHint: "Dalam mod terkunci, jarak gerakan = gerakan fizikal × {n}%",
    ctrlStickSensitivity: "Sensitiviti joistik kanan",
    ctrlStickHint:
      "Kelajuan putaran sasaran untuk permainan FPS / aksi. Joistik kiri (gerakan) tidak terjejas.",
    ctrlPrimaryClick: "Butang tetikus utama",
    ctrlLeftPrimary: "Kiri utama",
    ctrlRightPrimary: "Kanan utama",
    ctrlPrimaryClickHint:
      "Sesetengah permainan (cth. sebahagian permainan indie) menembak dengan klik kanan secara lalai dan perlu ditukar.",
    ctrlResetDefault: "Set semula",
    ctrlSavedToast: "Disimpan, berkuat kuasa kali seterusnya anda melancarkan",
    ctrlResetToast: "Dipulihkan ke konfigurasi pelayan",
    savesUploading: "Simpanan sedang dimuat naik — cuba lagi sebentar lagi",
    savesCheckFailed: "Gagal menyemak status simpanan — sila cuba lagi",
  },
  play: {
    stageReady: "Sedia",
    queueing: "Dalam giliran",
    queueJoining: "Menyertai giliran…",
    queueAheadPrefix: "",
    queueAheadSuffix: "pemain di hadapan anda",
    queueEta: "sekitar {n}s",
    cancelReturn: "Batal dan kembali",
    back: "Kembali",
    retry: "Cuba lagi",
    goSubscribe: "Naik taraf",
    entering: "Sedang masuk permainan",
    vipCta: "Naik taraf ke VIP untuk masuk sekarang",
    vipPerks: "Tanpa beratur + kualiti HD + sesi lebih lama",
    sessionExpiredHint:
      "Sesi biasanya tamat selepas menunggu lama — ketik \"Cuba lagi\" untuk beratur semula",
    lineOldUser: "Giliran pemain kembali",
    lineNewbie: "Giliran pemain baharu",
    lineFast: "Giliran laluan pantas",
    lineSvip: "Giliran SVIP",
    svipRequired: "Permainan ini SVIP sahaja. Sila naik taraf ke SVIP dahulu",
    stageConnectingServer: "Menyambung ke pelayan…",
    stageHandshake: "Bersalaman dengan pelayan…",
    stageP2pNegotiating: "Merunding saluran P2P…",
    stageMediaStreaming: "Menstrim media…",
    stageWaitingFrame: "Menunggu video…",
    stageVideoTrack: "Trek video diterima…",
    stageEntered: "Disambung",
    stageConnect: "Sambungan",
    stageConnectedSoon: "Disambung — video akan muncul sebentar lagi…",
    allocFailed: "Tidak dapat memperuntukkan pelayan permainan",
    allocFailedHttp: "Peruntukan gagal (HTTP {status})",
    reenterHint: " (sila keluar dan masuk semula permainan)",
    errP2pFailed: "Rundingan P2P gagal. Sila semak rangkaian anda",
    errDisconnected: "Sambungan terputus (code={code}). Sila cuba lagi",
    errStageFailed: "{stage} gagal",
    errStageFailedDetail: "{stage} gagal: {detail}",
    errConnectTimeout:
      "Sambungan tamat masa — tidak dapat mencapai pelayan. Semak rangkaian anda dan cuba lagi",
    errQueueCancelled: "Pelayan membatalkan giliran anda. Sila cuba lagi",
    errKicked:
      "Akaun anda telah log masuk di peranti lain, jadi sesi ini diputuskan",
    errCannotStart: "Tidak dapat memulakan permainan sekarang",
    registerFailed: "Pendaftaran gagal",
  },
  game: {
    recharge: "Tambah nilai",
    tabControl: "Kawalan",
    tabFrame: "Paparan",
    tabVoice: "Bunyi",
    controlScheme: "Mod kawalan",
    hideVirtualKeys: "Sembunyi kekunci maya",
    mouseMode: "Mod tetikus",
    mouseModeTouchpad: "Pad sentuh",
    mouseModeDrag: "Seret",
    mouseModeDirect: "Terus",
    mouseSensitivity: "Sensitiviti tetikus {n}%",
    rightStickMode: "Mod joistik kanan",
    joyModeFixed: "Tetap",
    joyModeHalf: "Separuh skrin",
    joyModeFull: "Skrin penuh",
    joyModeDrag: "Seret",
    stickSensitivity: "Sensitiviti joistik {n}%",
    customLayout: "Susun atur kekunci tersuai",
    editLayout: "Edit susun atur",
    frameComingSoon:
      "Penskalaan paparan / penukaran kualiti akan disertakan dalam versi kemudian.",
    gameSound: "Bunyi permainan",
    schemeFollow: "Ikut permainan",
    schemeGamepad: "Pengawal",
    schemeKeyMouse: "Papan kekunci & tetikus",
    schemeTouch: "Sentuh",
    schemeSwitchedGamepad: "Bertukar ke pengawal",
    schemeSwitchedKeyMouse: "Bertukar ke papan kekunci & tetikus",
    schemeSwitchedFollow: "Dipulihkan ke ikut permainan",
    modifierTitle: "Pengubah suai",
    modifierNeedUnlock: "Pengubah suai ini perlu dibeli untuk membuka kunci",
    usageTitle: "Arahan",
    usageEmpty: "Belum ada arahan",
    gotIt: "Faham",
    close: "Tutup",
    noModifiers: "Tiada pengubah suai",
    locked: "Berkunci",
    needUnlock: "Beli untuk buka kunci",
    remaining: "Tinggal {d}",
    use: "Guna",
    quitTitle: "Keluar permainan",
    quitConfirm: "Keluar dari permainan semasa?",
    quitConfirmBtn: "Keluar",
    quitCancelBtn: "Terus main",
    joyNameFixed: "Tetap",
    joyNameHalfZone: "Zon separuh skrin",
    joyNameFullFollow: "Ikut skrin penuh",
    joyNameDrag: "Seret",
    padConnected: "🎮 Pengawal disambung, kekunci maya disembunyikan",
    padDisconnected: "Pengawal diputuskan, kekunci maya dipulihkan",
    rightStickToast: "Joistik kanan: {name}",
    noEditableLayout: "Tiada susun atur kekunci boleh diedit",
    timeUsedUp: "Masa main telah habis",
    addTimeSuccess: "Masa ditambah",
    submitted: "Dihantar",
    minutesShort: "{n} min",
    addTime: "Tambah masa",
    expand: "Kembangkan",
    collapse: "Kuncupkan",
    physicalPadConnected: "Pengawal fizikal disambung",
    unmute: "Nyahsenyap",
    mute: "Senyap",
    fullscreen: "Skrin penuh",
    summonKeyboard: "Tunjuk papan kekunci",
    sensoryMode: "Kawalan gerakan",
    idleWarnTip: "Tiada aktiviti. Keluar dari permainan dalam {n} saat.",
    idleContinue: "Teruskan",
    nsInputTitle: "Permainan perlukan input teks",
    nsInputHint: "Taip teks, kemudian sahkan",
    settings: "Tetapan",
    currentRemaining: "Tinggal {n} minit",
    exchangeBeans: "Tukar masa dengan token",
    useAddTimeCard: "Guna kad tambah masa",
  },
  net: {
    requestFailed: "Permintaan gagal",
    errorWithCode: "Ralat {code}",
    serverError: "Ralat pelayan {status}",
    timeout: "Permintaan tamat masa",
    networkError: "Ralat rangkaian",
  },
  controls: {
    selectKeyFirst: "Pilih butang dahulu",
    saved: "Disimpan",
    saveFailed: "Gagal disimpan",
    selected: "Dipilih: {name}",
    keyFallback: "butang",
    hint: "Seret untuk ubah kedudukan; ketik untuk laras saiz / kelegapan / tindakan",
    size: "Saiz {pct}%",
    opacity: "Kelegapan {pct}%",
    operation: "Tindakan",
    opPress: "Tekan",
    opDrag: "Seret",
    opLock: "Kunci",
    delete: "Padam",
    addKey: "Tambah butang",
    reset: "Set semula",
    save: "Simpan",
    addHiddenKey: "Tambah butang tersembunyi",
    noHiddenKeys: "Tiada butang tersembunyi",
  },
};

export default messages;
